import { useWeb3 } from 'modules/blockChain/hooks/useWeb3'
import { useMemo } from 'react'
import { useGraphSWR } from '../hooks/useGraphSWR'
import {
  getQueryGraphWithdrawals,
  WithdrawalsResponse,
} from '../queries/withdrawals'

export function useGraphWithdrawalsSWR() {
  const { walletAddress } = useWeb3()
  const query = useMemo(
    () => walletAddress && getQueryGraphWithdrawals({ walletAddress }),
    [walletAddress],
  )
  const withdrawalsSwr = useGraphSWR<WithdrawalsResponse>(query)
  return {
    ...withdrawalsSwr,
    data: withdrawalsSwr.data?.data.withdrawals,
  }
}
